import { render, staticRenderFns } from "./ModalUser.vue?vue&type=template&id=532c89c8&scoped=true&"
import script from "./ModalUser.vue?vue&type=script&lang=js&"
export * from "./ModalUser.vue?vue&type=script&lang=js&"
import style0 from "./ModalUser.vue?vue&type=style&index=0&id=532c89c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532c89c8",
  null
  
)

export default component.exports